<script lang="ts">
  import { fade } from 'svelte/transition';
  import promos, { type Promo, categories } from './SKPromos';
  import { i18n } from '../../../util/i18n/i18n';
  import SKPromoItem from './SKPromoItem.svelte';
  import { trackEvent } from '../../../util/snowplow';
  import { userPrefersReducedMotion } from '@pin/dom-utils';

  let selected: (typeof categories)[0] = 'Mer Stjernekamp!';
  let filteredPromos: Array<Promo> = [];

  let answered = false;
  let shown = false;

  const handleClick = (response: 'yes' | 'no') => {
    trackEvent({ action: `click:promo-${response}` });
    answered = true;
    setTimeout(() => {
      shown = true;
    }, 5_000);
  };

  const handleCategoryClick = () => {
    trackEvent({ action: 'click:category-change', label: selected });

    const scrollToElement = document.getElementsByTagName('article')[0];
    const behavior = userPrefersReducedMotion() ? 'auto' : 'smooth';
    scrollToElement.scrollIntoView({ behavior });
  };

  const filterPromos = (selected: string) => {
    filteredPromos = promos.filter((promo) => promo.category === selected);
  };
  $: filterPromos(selected);
</script>

<svelte:head>
  {#each promos as promo}
    <link rel="preload" as="image" href={promo.img} />
  {/each}
</svelte:head>

<article>
  <h2>{i18n('promo.heading')}</h2>
  <ul>
    <fieldset class="categories">
      {#each categories as category, i}
        <label>
          <input
            type="radio"
            bind:group={selected}
            value={category}
            on:click={handleCategoryClick}
          />
          <div class="category" class:selected={categories[i] === selected}>
            {category}
          </div>
        </label>
      {/each}
    </fieldset>
    {#each filteredPromos as promo (promo.href)}
      <SKPromoItem {promo} />
    {/each}
    <div class="feedback-container">
      {#if !answered}
        <div
          class="feedback-item"
          in:fade={{ delay: 0, duration: 250 }}
          out:fade
        >
          <div class="button-header">Liker du å få tips på denne måten?</div>
          <div class="button-wrapper">
            <button on:click={() => handleClick('yes')}>Ja 👍</button>
            <button on:click={() => handleClick('no')}>Nei 👎</button>
          </div>
        </div>
      {:else if !shown}
        <div
          class="button-header feedback-item"
          in:fade={{ delay: 0, duration: 250 }}
          out:fade
        >
          Takk for din tilbakemelding!
        </div>
      {/if}
    </div>
  </ul>
</article>

<style>
  article {
    background: rgba(0, 0, 0, 0.6);
    padding: 1rem 0;
    color: var(--sk-light-pink);
    text-align: center;
    margin: -1rem;
    width: calc(100% + 2rem);
  }

  h2 {
    margin: 1rem 0;
    text-transform: unset;
    color: var(--sk-lighter-blue);
    font-style: normal;
  }

  .categories,
  .button-wrapper {
    max-width: 30rem;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .categories {
    border: none;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .category,
  button {
    background: #0c366c;
    color: #b2cff5;
  }

  .category {
    border-radius: 3px;
    padding: 0.2rem 0.8rem;
    cursor: pointer;
  }

  .selected {
    background: #b2cff5;
    color: #0c366c;
  }

  input {
    display: none;
  }

  ul {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .feedback-container {
    display: grid;
  }

  .feedback-item {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 2;
  }
  .button-header {
    font-size: 1.2rem;
    color: white;
  }
  .button-wrapper {
    width: 100%;
    gap: 1rem;
    padding: 1rem;
  }
  button {
    flex-grow: 1;
    text-transform: unset;
  }
</style>
